import React, {useEffect, useRef, useState} from 'react';
import PropTypes from "prop-types";
import * as Icon from 'ubs-icons';
import useDebouncedEffect from "use-debounced-effect";
import {LENGTH, TIMEOUT} from "../../constant";
import useEscKey from "../../hooks/useEscKey";

const UFilterSearch = React.memo((props) => {
    const ref = useRef(null);
    const [search, setSearch] = useState(props?.search || '');

    useEffect(() => {
        setSearch(props?.search);
    }, [props?.search]);

    useEffect(() => {
        if(props?.focus) ref?.current?.focus()
    }, [props?.focus]);
    
    const handleKey = (e) => {
        if ((e.metaKey || e.ctrlKey) && e.code === 'KeyJ') {
            e.preventDefault();
            ref?.current?.focus();
        }
    };

    useEscKey(() => {
        if (props?.closeOnEsc && ref?.current === document.activeElement) {
            setSearch('');
            ref?.current?.blur();
        }
    })

    useDebouncedEffect(() => {
        if (props.onSearch && (search?.length === 0 || search?.length >= LENGTH.SEARCH)) props.onSearch(search)
    }, TIMEOUT.DE_BOUNCING, [search]);

    useEffect(() => {
        document.addEventListener("keydown", handleKey, true);

        return () => document.removeEventListener("keydown", handleKey, true);
    }, []);

    return (
        <div className={`u_filters u_filters-search ${search?.length !== 0 ? 'active' : ''}`}>
            <span className="u_search-icon u_cp" onClick={() => ref?.current?.focus()}><Icon.Search size={14} fill={search?.length !== 0 ? '#007AFF' : '#4E525F'}/></span>
            <input type="text" tabIndex="0" className="u_input" placeholder={props?.placeholder ? props?.placeholder : "Search"} ref={ref} value={search} onChange={e => setSearch(e.target.value)} onBlur={props?.blur} autoComplete="off" />
            {search?.length !== 0 &&
            <span className="u_delete-icon u_cp" onClick={() => setSearch('')}><Icon.Close size={14} fill={search?.length !== 0 ? '#007AFF' : '#4E525F'}/></span>}
        </div>
    );
});

UFilterSearch.propTypes = {
    search: PropTypes.string,
    onSearch: PropTypes.func,
    closeOnEsc: PropTypes.bool
}
UFilterSearch.defaultProps = {
    search: '',
    onSearch: () => {
    },
    closeOnEsc: true
};

export default UFilterSearch;